export default __webpack_public_path__ + "static/mijeanne@2x-7032890e40fefc39649a70e7c4f06d30.png";